<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="申请人：">
        <el-input v-model="query.applicantInfo" placeholder="请输入申请人姓名/手机号" size="small" clearable />
      </el-form-item>
      <el-form-item label="审核状态：">
        <el-select v-model="query.auditStatus" placeholder="全部" clearable size="small" style="width: 120px;">
          <el-option label="待审核" :value="0" />
          <el-option label="同意申请" :value="1" />
          <el-option label="驳回申请" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="提交时间：">
        <el-date-picker
          v-model="dateTime"
          size="small"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始"
          end-placeholder="结束"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleExport" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import discountModificationAuditApi from '@/api/finance/discountModificationAudit'
import { filterEmpty } from '@/utils'

export default {
  data() {
    return {
      dateTime: [],
      query: {
        applicantInfo: undefined,
        auditStatus: undefined
      }
    }
  },
  methods: {
    handleExport() {
      const params = {
        nameOrPho: this.query.applicantInfo,
        state: this.query.auditStatus,
        startCreatedTime: this.dateTime && this.dateTime.length >= 2 ? this.dateTime[0] : undefined,
        endCreatedTime: this.dateTime && this.dateTime.length >= 2 ? this.dateTime[1] : undefined
      }
      return this.$common
        .confirm('是否确认导出')
        .then(() => discountModificationAuditApi.downloadChangProfitRatio(filterEmpty(params)))
        .then(() => {
          this.$message.success('导出成功')
          this.$emit('created')
        })
        .catch(err => {
          this.$message.error(err.msg || err.message || '导出失败')
        })
    }
  }
}
</script>
